import React, {useState, useEffect} from 'react';
import {t} from 'react-switch-lang';
import DownloadBtn from './reportForm/components/downloadBtn/DownloadBtn';
import {useUserContext} from '../../contexts/UserContext';
import * as yup from 'yup';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import InputDate from '../../components/FormFields/inputDate/InputDate';
import {format} from 'date-fns';
import './Report.scss';

const KriReport = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const schema = yup.object().shape({
    startDate: yup.object().nullable().required(t('message.fieldRequired')),
    endDate: yup.object().nullable().required(t('message.fieldRequired')),
  });

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {watch } = methods;
  let validFrom = watch('startDate');
  let validTo = watch('endDate');

  const user = useUserContext();

  let userRiskSector = false;
  let responsibleUser = false;
  let userInCharge = false;

  user.authorities.forEach((item) => {
    if (item === 'ROLE_RISK_SECTOR') {
      userRiskSector = true;
    }
    if (item === 'ROLE_RESPONSIBLE_USER') {
      responsibleUser = true;
    }
    if (item === 'ROLE_USER_IN_CHARGE') {
      userInCharge = true;
    }
  });

  useEffect(() => {
    setIsSubmitted(false);
  }, []);

  return (
    <div className="reports-page content">
      <FormProvider {...methods}>
        <div className="report-form-container" key={window.location.pathname}>
          <div className="row  ml-0 mr-0">
            <div className="form-group pr-5">
              <label className="label" htmlFor="startDate">
                {t('reports.dateFrom')}
              </label>
              <InputDate
                name="startDate"
                maxDate={validTo}
                className={`date-height form-control ${
                  validFrom === null && isSubmitted === true ? `error-field` : ''
                }`}
                isClearable={false}
                placeholderText={t('reports.dateFrom')}
              />
              {
                validFrom === null && isSubmitted === true
              ? <span className="error-message position-absolute">{t('message.fieldRequired')}</span>
                : ''
              }
            </div>
            <div className="form-group pr-5">
              <label className="label" htmlFor="endDate">
                {t('reports.dateTo')}
              </label>
              <InputDate
                name="endDate"
                className={`date-height form-control ${
                  validTo === null && isSubmitted === true ? `error-field` : ''
                }`}
                isClearable={false}
                placeholderText={t('reports.dateTo')}
                minDate={validFrom}
              />
              {
                validTo === null && isSubmitted === true
                  ? <span className="error-message position-absolute">{t('message.fieldRequired')}</span>
                  : ''
              }
            </div>
            <DownloadBtn
              api={'key-indicators/key-indicator-and-occurences-report'}
              paramsLength={2}
              setIsSubmitted={(e) => setIsSubmitted(e)}
              apiParameters={{
                date:
                  validFrom !== null && validFrom !== undefined
                    ? `dateFrom=${encodeURIComponent(
                        format(validFrom, 'yyyy-MM-dd'))}`
                    : '',
                dateValidTo:
                  validTo !== null && validTo !== undefined
                    ? `dateTo=${encodeURIComponent(
                      format(validTo, 'yyyy-MM-dd'))}`
                    : '',
              }}
            />
          </div>
        </div>
      </FormProvider>
    </div>
  );
};

export default KriReport;
